import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import reportService from './reportService';

const initialState = {
  report: null,
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: '',
  reportSetup: null,
  reportSetups: null,
  reportSetting: null
};

export const fetchUpdatedInventory = createAsyncThunk('report/updated_inventory', async ({ pageNum, spaceBookingId }, thunkAPI) => {
  try {
    return await reportService.fetchUpdatedInventory(pageNum, spaceBookingId);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const fetchLocationWiseInventory = createAsyncThunk(
  'report/location_wise_inventory',
  async ({ pageNum, spaceBookingId }, thunkAPI) => {
    try {
      return await reportService.fetchLocationWiseInventory(pageNum, spaceBookingId);
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchDamageInventory = createAsyncThunk('report/damage_inventory', async ({ pageNum, spaceBookingId }, thunkAPI) => {
  try {
    return await reportService.fetchDamageInventory(pageNum, spaceBookingId);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const createReportSetup = createAsyncThunk('report_setup/create_report_setup', async (reportSetupData, thunkAPI) => {
  try {
    return await reportService.createReportSetup(reportSetupData);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const fetchReportSetupList = createAsyncThunk('report_setup/list', async ({ pageNum, organizationId }, thunkAPI) => {
  try {
    return await reportService.fetchReportSetupList(pageNum, organizationId);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const reportSetupStatus = createAsyncThunk('report_setup/status', async (data, thunkAPI) => {
  try {
    return await reportService.reportSetupStatus(data);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const fetchReportSetupDetail = createAsyncThunk('report_setup/get_single', async (data, thunkAPI) => {
  try {
    return await reportService.fetchReportSetupDetail(data);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateReportSetup = createAsyncThunk('report_setup/edit', async (data, thunkAPI) => {
  try {
    return await reportService.updateReportSetup(data);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const addReportSetting = createAsyncThunk('report_setup/add_report_setting', async (reportSettingData, thunkAPI) => {
  try {
    return await reportService.addReportSetting(reportSettingData);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const fetchReportSettingDetail = createAsyncThunk('report_setup/report_setting_detail', async (data, thunkAPI) => {
  try {
    return await reportService.fetchReportSettingDetail(data);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const testMailReport = createAsyncThunk('report_setup/test_mail', async (data, thunkAPI) => {
  try {
    return await reportService.testMailReport(data);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const fetchLedgerReport = createAsyncThunk('report/ledger_report', async ({ pageNum, data }, thunkAPI) => {
  try {
    return await reportService.fetchLedgerReport(pageNum, data);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const reportSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUpdatedInventory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchUpdatedInventory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.report = action.payload;
      })
      .addCase(fetchUpdatedInventory.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(fetchLocationWiseInventory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchLocationWiseInventory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.report = action.payload;
      })
      .addCase(fetchLocationWiseInventory.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(fetchDamageInventory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchDamageInventory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.report = action.payload;
      })
      .addCase(fetchDamageInventory.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(createReportSetup.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createReportSetup.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.reportSetup = action.payload;
      })
      .addCase(createReportSetup.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(fetchReportSetupList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchReportSetupList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.reportSetups = action.payload;
      })
      .addCase(fetchReportSetupList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(reportSetupStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(reportSetupStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.reportSetup = action.payload;
      })
      .addCase(reportSetupStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(fetchReportSetupDetail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchReportSetupDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.reportSetup = action.payload;
      })
      .addCase(fetchReportSetupDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateReportSetup.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateReportSetup.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.reportSetup = action.payload;
      })
      .addCase(updateReportSetup.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(addReportSetting.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addReportSetting.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.reportSetting = action.payload;
      })
      .addCase(addReportSetting.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(fetchReportSettingDetail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchReportSettingDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.reportSetting = action.payload;
      })
      .addCase(fetchReportSettingDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(testMailReport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(testMailReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.report = action.payload;
      })
      .addCase(testMailReport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(fetchLedgerReport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchLedgerReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.report = action.payload;
      })
      .addCase(fetchLedgerReport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  }
});

export const { reset } = reportSlice.actions;
export default reportSlice.reducer;
